import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import EnhancedTable from 'components/EnhancedTable';
import SimpleTableToolbar from 'components/SimpleTableToolbar';
import ExpandButton from 'components/ExpandButton';
import SearchBox from 'components/SearchBox';
import SalesReturnFormView from './SalesReturnFormView';

function SalesReturnFormDetail({ userMapping, salesReturnForm, ...props }) {
  const r = { ...salesReturnForm }
  const keys = salesReturnForm.merchandises ? Object.keys(salesReturnForm.merchandises) : []
  r.merchandises = keys.map(k => {
    return {
      ...r.merchandises[k],
      id: k,
      price: r.merchandises[k].items.reduce((acc, cur) => acc + (cur.unitPrice * cur.amount), 0)
    }
  })

  r.createdBy = { id: r.createdBy, name: userMapping[r.createdBy]?.displayName }
  return (
    <div style={{ padding: 15 }}>
      <SalesReturnFormView userMapping={userMapping} salesReturnForm={r} {...props} />
    </div>
  )
}

SalesReturnFormDetail.propTypes = {
  salesReturnForm: PropTypes.object.isRequired,
  userMapping: PropTypes.object.isRequired,
  merchandiseMapping: PropTypes.object.isRequired,
};

function SalesReturnFormList({ salesReturnForms, title }) {
  const { formatMessage } = useIntl()
  const userMapping = useSelector(state => state.users.data)
  const customerMapping = useSelector(state => state.internalVendors.data)
  const supplierMapping = useSelector(state => state.suppliers.data)
  const merchandiseMapping = useSelector(state => state.merchandises.data)

  const [currentFilter, setCurrentFilter] = useState(null)
  const [expand, setExpand] = useState(true);

  const filteredSalesReturnForms = currentFilter && currentFilter.text ? filterByText() : salesReturnForms

  const headerCells = [
    { text: 'sn', sort: 'sn' },
    { text: 'sourceName', sort: 'sourceName' },
    { text: 'supplierName', sort: 'supplierName' },
    // {text: 'createdBy', sort: 'createdBy'},
    { text: 'date', sort: 'date' },
  ].map(c => {c.text = formatMessage({ id: `salesReturnForm.table.header.${c.text}` });return c})

  const rowCells = [
    { field: 'sn' },
    { field: 'sourceName' },
    { field: 'supplierName' },
    // {field: 'createdBy'},
    { field: 'date' },
  ]

  function filterByText() {
    if (currentFilter.name === 'sourceName') {
      return salesReturnForms.filter(s => customerMapping[s.source]?.nickname.toLowerCase().includes(currentFilter.text.toLowerCase()))
    } else if (currentFilter.name === 'supplierName') {
      return salesReturnForms.filter(s => supplierMapping[s.supplier]?.displayName.toLowerCase().includes(currentFilter.text.toLowerCase()))
    } else if (currentFilter.name === 'createdBy') {
      return salesReturnForms.filter(s => userMapping[s.createdBy]?.displayName.toLowerCase().includes(currentFilter.text.toLowerCase()))
    } else {
      return salesReturnForms.filter(s => s[currentFilter.name].toLowerCase().includes(currentFilter.text.toLowerCase()))
    }
  }

  const formatData = (salesReturnForm) => {
    const newData = { ...salesReturnForm }
    newData.sourceName = customerMapping[newData.source]?.nickname
    newData.supplierName = supplierMapping[newData.destination]?.nickname
    newData.createdBy = userMapping[newData.createdBy]?.displayName
    return newData
  }

  const filterItems = [
    { name: 'sn' },
    { name: 'sourceName', type: 'customer' },
    { name: 'supplierName' },
    { name: 'createdBy' },
    { name: 'note' },
  ].map(i => {i.text = formatMessage({ id: `salesReturnForm.table.detail.${i.name}` });return i})

  const onFilterChanged = (name, text) => {
    if (text !== '') {
      setCurrentFilter({ name, text })
    } else {
      setCurrentFilter(null)
    }
  }

  return (
    <div>
      <SimpleTableToolbar
        title={title}
        buttons={<ExpandButton open={expand} onExpandChange={setExpand} />}
        toolbox={<SearchBox filterItems={filterItems} onFilterChanged={onFilterChanged} />}
      />
      <EnhancedTable
        defaultOrder="desc"
        defaultOrderField="sn"
        headerCells={headerCells}
        rowCells={rowCells}
        getExpandContent={salesReturnForm =>
          <SalesReturnFormDetail
            userMapping={userMapping}
            merchandiseMapping={merchandiseMapping}
            salesReturnForm={salesReturnForm}
          />
        }
        tableData={filteredSalesReturnForms.map(r => formatData(r))}
      />
    </div>
  );
}

SalesReturnFormList.propTypes = {
  salesReturnForms: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  title: PropTypes.string.isRequired,
};

export default SalesReturnFormList;
